export default __webpack_public_path__ + "img/4.7b4fe77b.jpg";